import React, { useCallback, useRef } from "react";
import styled from "@emotion/styled";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import rrulePlugin from "@fullcalendar/rrule";
import listPlugin from "@fullcalendar/list";
import { Badge } from "antd";
import dayjs from "dayjs";

const DateItemWrapper = styled.div(() => ({
  cursor: "pointer",
}));

const DateItem = styled(Badge)(() => ({
  padding: "0 0.6rem",
  color: "white !important",
}));
const CustomFullCalendar = ({ events, setBody, listRef }) => {
  const calendarRef = useRef(null);

  const scrollIntoList = useCallback(() => {
    listRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }, [listRef]);

  const renderEventContent = eventInfo => {
    return (
      <DateItemWrapper onClick={eventInfo => scrollIntoList(eventInfo)}>
        <DateItem status="error" text={eventInfo.event.title} />
      </DateItemWrapper>
    );
  };

  return (
    <FullCalendar
      plugins={[dayGridPlugin, rrulePlugin, listPlugin]}
      eventContent={renderEventContent}
      initialView="dayGridMonth"
      locale="kr"
      buttonText={{
        today: "오늘",
      }}
      ref={calendarRef}
      events={events}
      datesSet={function (dateInfo) {
        const dateCurrent = dayjs(dateInfo.endStr)
          .subtract(1, "month")
          .format("YYYY-MM");

        setBody({
          calendarEvent: {
            date_from: dateCurrent,
            date_to: dateCurrent,
            month_prev: dayjs(dateCurrent).format("MM"),
            month_current: dayjs(dateCurrent).format("MM"),
            month_next: dayjs(dateCurrent).format("MM"),
          },
          currentMonthEvent: {
            date_from: dateCurrent,
            date_to: dateCurrent,
            month_prev: dayjs(dateCurrent).format("MM"),
            month_current: dayjs(dateCurrent).format("MM"),
            month_next: dayjs(dateCurrent).format("MM"),
          },
        });
      }}
    />
  );
};

export default CustomFullCalendar;
